import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/escuela_programa/escuela'

const getEscuelas = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const crearEscuela = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarEscuela = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre, onSuccessMessage }
}

const actualizarEscuela = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getEscuelas,
  crearEscuela,
  eliminarEscuela,
  actualizarEscuela,
}